<template>
  <div class="edition">
    <!-- <zt-button class="add" type="text" @click="dialogVisible=true">+新增版本</zt-button> -->

    <el-tabs v-model="active" ref="tabs">
      <el-tab-pane label="iOS" name="0">
        <el-table :data="historyList.iosList">
          <el-table-column prop="ver" label="版本号"></el-table-column>
          <el-table-column prop="add_time" label="更新时间"></el-table-column>
          <el-table-column prop="change_log" label="更新内容"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="Android(安卓)" name="1">
        <el-table :data="historyList.androidList">
          <el-table-column prop="ver" label="版本号"></el-table-column>
          <el-table-column prop="add_time" label="更新时间"></el-table-column>
          <el-table-column prop="change_log" label="更新内容"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- <el-dialog title="新增版本" :visible.sync="dialogVisible" width="580px">
      <el-form label-width="90px" label-position="left" class="form">
        <el-form-item label="版本号">
          <zt-input class="admin-input" placeholder="请填写版本号"></zt-input>
        </el-form-item>
        <el-form-item label="更新时间">
          <el-date-picker v-model="updataTime" type="date" placeholder="请选择时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="更新内容">
          <zt-input class="admin-input" placeholder="请输入更新内容" type="textarea" :rows="5"></zt-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <zt-button class="submitbtn" type="primary" @click="dialogVisible = false">提交</zt-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  props:{
    historyList:Object,
  },
  computed: {
    active: {
      get() {
        return this.$store.state.tabs.pluginAppHistory;
      },
      set(val) {
        this.$store.dispatch('ChangeTabs', {
          name: 'pluginAppHistory',
          current: val,
        });
      },
    },
    
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
#app .el-table {
  /deep/.el-table--border th:first-child .cell,
  /deep/.el-table--border td:first-child .cell,
  /deep/ .cell {
    padding-left: 10px;
    text-overflow: unset;
  }
}
.form {
  padding-left: 12px;
}
.edition {
  position: relative;
  .add {
    position: absolute;
    right: 0px;
    cursor: pointer;
    z-index: 1;
  }
}
/deep/ .admin-input {
  width: 411px !important;
}
.submitbtn {
  width: 139px;
  height: 36px;
}
</style>